export const OTHER_ADJOURNMENT_REASON = 'Other (Must Include Reason)';

export const reasonForAdjournmentOptions = [
  {
    value: "Cash to Close",
    label: "Cash to Close"
  },
  {
    value: "Borrower didn't accept the terms",
    label: "Borrower didn't accept the terms"
  },
  {
    value: "Borrower Issue (Other)",
    label: "Borrower Issue (Other)"
  },
  {
    value: "Seller Not Ready",
    label: "Seller Not Ready"
  },
  {
    value: "Title Not Ready",
    label: "Title Not Ready"
  },
  {
    value: OTHER_ADJOURNMENT_REASON,
    label: OTHER_ADJOURNMENT_REASON
  }
]
